import noty from '@/plugins/noty'

export const liveCoachJoinedNotification = ({ name }) => {
  return noty({
    type: 'info',
    timeout: 5000,
    text: `${name} has joined as a coach`
  })()
}

export const liveCoachLeftNotification = ({ name }) => {
  return noty({
    type: 'info',
    timeout: 5000,
    text: `${name} has left the call`
  })()
}

export const liveCoachMessageNotification = ({ name, message, onClick }) => {
  return noty({
    type: 'info',
    timeout: 10000,
    text: `${name}: ${message}`,
    closeWith: ['click', 'button'],
    callbacks: {
      onClick
    }
  })()
}

export const recordingStartedNotification = noty({
  type: 'info',
  timeout: 3000,
  queue: 'recording',
  killer: 'recording',
  text: 'Recording started'
})

export const recordingPausedNotification = noty({
  type: 'info',
  timeout: 3000,
  queue: 'recording',
  killer: 'recording',
  text: 'Recording paused'
})

export const recordingResumedNotification = noty({
  type: 'info',
  timeout: 3000,
  queue: 'recording',
  killer: 'recording',
  text: 'Recording resumed'
})

export const recordingStoppedNotification = noty({
  type: 'info',
  timeout: 3000,
  queue: 'recording',
  killer: 'recording',
  text: 'Recording stopped'
})

export const repBusyNotification = ({ phoneNumber }) => {
  return noty({
    type: 'error',
    timeout: 30000,
    text: `We tried to call you on ${phoneNumber} but the handset was busy`
  })()
}

export const customerBusyNotification = noty({
  type: 'info',
  timeout: 5000,
  text: 'Your customer is already on a call or busy'
})

export const repNotAnsweredNotification = ({ phoneNumber }) => {
  return noty({
    type: 'error',
    timeout: 30000,
    text: `We tried to call you on ${phoneNumber} but but you didn’t answer`
  })()
}

export const customerNotAnsweredNotification = noty({
  type: 'info',
  timeout: 5000,
  text: 'Your customer did not answer their phone'
})

export const callToRepFailedNotification = ({ phoneNumber }) => {
  return noty({
    type: 'error',
    timeout: 30000,
    text: `We tried to call you on ${phoneNumber} but the call failed. Please check the number is valid or contact support.`
  })()
}

export const callToCustomerFailedNotification = ({ crmName }) => {
  return noty({
    type: 'error',
    timeout: 30000,
    text: `Sorry, we could not place the call. Please check the number is valid and formatted correctly in ${crmName}. Try to prefix the international dial code e.g. +44 for the UK.`
  })()
}



// WEBPACK FOOTER //
// ./src/components/rep-call/with-pusher-subscription/notifications.js